import { atom } from 'recoil';
export const setPatientGeneralInfo = atom({
    key: "setPatientGeneralInfo",
    default: [],
});